module.exports = __webpack_public_path__ + "img/annie-spratt-Iqwnr00mfQM-unsplash.27ffc390.jpg";